import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
	return (
		<>
			<div className="auth-page container-fluid admin">
				<div className="row fullscreen">
					<div className="col-lg-6 col-sm-12 col-md-12 d-none d-xl-block p-0">
						<div className="bg-wrapper">
							<div className="slider-wrapper"></div>
						</div>
					</div>
					<div className="col-lg-6 col-sm-12 col-md-12 p-0">
						<div className="login-content h-100 d-flex justify-content-center align-items-center">
							<div className="content-wrapper login-input-container">
								<Outlet />
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AuthLayout;
